//在此处编写调用授权等基本平台接口
class op_api {
  constructor(axiosFactory) {
    this.$http = axiosFactory;
  }
  http() {
    return this.$http;
  }
  get(url, cb) {
    this.$http.get(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });;
  }
  gets(url, data, cb) {
    this.$http.get(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  post(url, data, cb) {
    this.$http.post(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  posts(url, cb) {
    this.$http.post(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  put(url, data, cb) {
    this.$http.put(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  puts(url, cb) {
    this.$http.put(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  delete(url, data, cb) {
    this.$http.delete(url, data).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }
  deletes(url, cb) {
    this.$http.delete(url).then(res => {
      cb(res.data);
    }).catch(err => {
      cb(err);
    });
  }

  //先判定本地是否存储，如果没有能够获取到本地存储，再次从远程获取；
  //key存储字段，url请求地址，cb回调函数
  getStorageData(key, url, cb) {
    this.$http.get(url).then(value => {
      cb(value.data);
      var curTime = new Date().getTime();
      localStorage.setItem(
        key,
        JSON.stringify({
          data: value.data,
          time: curTime
        })
      );
    });
  }
  //控制localStorage过期控制代码
  changeStorageData(key, url, cb, exp) {
    var data = localStorage.getItem(key);
    var myObj = JSON.parse(data);
    if (myObj) {
      if (new Date().getTime() - myObj.time > exp) {
        this.getStorageData(key, url, cb);
      } else {
        cb(myObj.data);
      }
    } else {
      this.getStorageData(key, url, cb);
    }
  }

  getHunter(id, cb) {
    this.get(`/www/hunter/${id}/profile`, cb);
  }
  //------------------------------------------------------------

  //获取热招行业
  //604800000 ----- 7天
  gethotworks(cb) {
    this.changeStorageData("hotworks", `/www/hotmaps`, cb, 604800000);
  }
  getartices(id, size, cb) {
    this.get(`/www/news?pageNum=1&pageSize=${size}&categoryId=${id}`, cb);
  }
  getarticeDetail(id, cb) {
    this.get(`/www/news/${id}`, cb);
  }

  //联系我们提交信息
  postContactUs(data, cb) {
    this.post("/www/concatUs", data, cb);
  }

  //[求职者-重置密码-邮箱找回-根据邮箱改密码]
  postRestPwdByEmail(data, cb) {
    this.post("/www/reset/password/email", data, cb)
  }
}
class apiFactory {
  constructor() {

  }
  createApi(axios) {
    return new op_api(axios)
  }
}
export default new apiFactory();
